// Mock data for frontend-only demonstration
// This will be replaced with real backend integration later

export const mockContactSubmit = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock contact form submission:', formData);
      resolve({ success: true, message: 'Votre demande a été envoyée avec succès!' });
    }, 1000);
  });
};

export const servicesData = {
  personalCare: {
    title: 'Aides à la personne',
    description: 'Des services personnalisés pour vous accompagner au quotidien',
    services: [
      {
        title: 'Réalisation de repas',
        description: 'Préparation de repas équilibrés et adaptés à vos besoins',
        icon: 'ChefHat'
      },
      {
        title: 'Réalisation des courses',
        description: 'Accompagnement ou prise en charge de vos courses quotidiennes',
        icon: 'ShoppingCart'
      },
      {
        title: 'Accompagnement aux rendez-vous médicaux',
        description: 'Transport et présence lors de vos consultations médicales',
        icon: 'Stethoscope'
      },
      {
        title: 'Accompagnement aux activités de loisirs',
        description: 'Sorties culturelles, promenades et activités sociales',
        icon: 'Heart'
      }
    ]
  },
  childcare: {
    title: 'Garde d\'enfant',
    description: 'Un accompagnement bienveillant pour vos enfants',
    services: [
      {
        title: 'Garde d\'enfants à domicile',
        description: 'Surveillance et activités adaptées à l\'âge de vos enfants',
        icon: 'Baby'
      },
      {
        title: 'Garde partagée d\'enfants',
        description: 'Solution économique avec d\'autres familles',
        icon: 'Users'
      },
      {
        title: 'Trajet domicile – École / Crèche',
        description: 'Transport sécurisé de vos enfants',
        icon: 'Bus'
      },
      {
        title: 'Aide aux devoirs',
        description: 'Accompagnement scolaire personnalisé',
        icon: 'BookOpen'
      },
      {
        title: 'Accompagnement aux activités extra-scolaires',
        description: 'Transport et présence aux activités de vos enfants',
        icon: 'Palette'
      }
    ]
  },
  cleaning: {
    title: 'Ménage et repassage',
    description: 'Des services d\'entretien pour particuliers et entreprises',
    services: [
      {
        title: 'Ménage régulier',
        description: 'Entretien hebdomadaire ou mensuel de votre domicile',
        icon: 'Sparkles'
      },
      {
        title: 'Grand ménage',
        description: 'Nettoyage en profondeur de toutes les pièces',
        icon: 'Droplets'
      },
      {
        title: 'Repassage',
        description: 'Service de repassage à domicile',
        icon: 'Wind'
      },
      {
        title: 'Ménage après travaux',
        description: 'Nettoyage post-rénovation ou déménagement',
        icon: 'Hammer'
      },
      {
        title: 'Ménage entreprise',
        description: 'Entretien de bureaux et locaux professionnels',
        icon: 'Building'
      }
    ]
  },
  handyman: {
    title: 'Bricolage et jardinage',
    description: 'Petits travaux et entretien extérieur',
    services: [
      {
        title: 'Petits travaux de bricolage',
        description: 'Montage de meubles, fixations murales, petites réparations',
        icon: 'Wrench'
      },
      {
        title: 'Entretien du jardin',
        description: 'Tonte, taille, désherbage et entretien des espaces verts',
        icon: 'Leaf'
      },
      {
        title: 'Petit jardinage',
        description: 'Plantation, arrosage et soins des plantes',
        icon: 'Flower2'
      },
      {
        title: 'Travaux saisonniers',
        description: 'Ramassage des feuilles, déneigement',
        icon: 'Cloud'
      }
    ]
  },
  itSupport: {
    title: 'Informatique pour particulier',
    description: 'Assistance informatique à domicile avec pédagogie',
    services: [
      {
        title: 'Initiation informatique',
        description: 'Apprentissage des bases de l\'ordinateur et d\'internet',
        icon: 'Monitor'
      },
      {
        title: 'Aide smartphone et tablette',
        description: 'Prise en main de vos appareils mobiles',
        icon: 'Smartphone'
      },
      {
        title: 'Installation et configuration',
        description: 'Mise en place de logiciels et connexion internet',
        icon: 'Settings'
      },
      {
        title: 'Dépannage informatique',
        description: 'Résolution de problèmes techniques simples',
        icon: 'HardDrive'
      },
      {
        title: 'Formation internet',
        description: 'Navigation web, emails, réseaux sociaux',
        icon: 'Globe'
      }
    ]
  }
};